import React, { useEffect, useState } from 'react';
import { devCost, fmtAED } from '../utils';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { productsAPI } from '../api';

const STATUS_LABELS = {
  trial: 'Trial', recipe_confirmed: 'Recipe Confirmed',
  commercial_trial: 'Commercial Trial', launched: 'Launched',
};

export default function DepartmentView() {
  const [products, setProducts] = useState([]);
  const [filterSfg, setFilterSfg] = useState('');
  const [grouped, setGrouped] = useState({});
  const [selectedDept, setSelectedDept] = useState(null);

  const printPDF = () => {
    if (!selectedDept || !grouped[selectedDept]) return;
    const today = new Date().toLocaleDateString('en-AE', { day: '2-digit', month: 'short', year: 'numeric' });
    const userName = (() => { try { const u = JSON.parse(localStorage.getItem('npd_user')); return u?.name || u?.username || ''; } catch { return ''; } })();
    const deptProducts = grouped[selectedDept];
    const STATUS_LABELS = { trial:'Trial', recipe_confirmed:'Recipe Confirmed', commercial_trial:'Commercial Trial', launched:'Launched' };
    const STATUS_COLORS = { trial:'#e67e00', recipe_confirmed:'#2e7d32', commercial_trial:'#1a56db', launched:'#7B2D6B' };
    const STATUS_BG = { trial:'#fff3e0', recipe_confirmed:'#f0faf0', commercial_trial:'#e8f0fe', launched:'#f3e8ff' };

    const rows = deptProducts.map((p, idx) => `
      <tr style="${idx%2===1?'background:#fdf9fc;':''}">
        <td style="font-family:'Courier New',monospace;font-size:9px;color:#7B2D6B;font-weight:600;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${p.product_code}</td>
        <td style="font-size:10px;font-weight:500;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${p.name}</td>
        <td style="padding:5px 8px;border-bottom:0.5px solid #f5edf3;text-align:center;">
          <span style="display:inline-block;padding:1px 8px;border-radius:20px;font-size:8px;font-weight:600;background:${STATUS_BG[p.status]||'#f5f5f5'};color:${STATUS_COLORS[p.status]||'#555'}">${STATUS_LABELS[p.status]||p.status}</span>
        </td>
        <td style="font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;color:#888;">${p.project_name||'—'}</td>
        <td style="font-family:monospace;font-size:9px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;color:#888;">${p.internal_group||'—'}</td>
        <td style="font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;text-align:right;font-weight:600;color:#7B2D6B;">${(devCost(p)) > 0 ? 'AED '+(devCost(p)).toLocaleString('en-AE',{maximumFractionDigits:0}) : '—'}</td>
      </tr>`).join('');

    const statusCount = deptProducts.reduce((acc, p) => { acc[p.status]=(acc[p.status]||0)+1; return acc; }, {});
    const statusSummary = ['trial','recipe_confirmed','commercial_trial','launched'].map(s => `
      <div style="text-align:center;padding:8px 14px;border-right:1px solid #e4d4e0;">
        <div style="font-size:7px;letter-spacing:0.14em;text-transform:uppercase;color:#c0a0b8;margin-bottom:3px;">${STATUS_LABELS[s]}</div>
        <div style="font-size:16px;font-weight:700;color:${STATUS_COLORS[s]};">${statusCount[s]||0}</div>
      </div>`).join('');

    const win = window.open('', '_blank');
    win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8">
    <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
    <style>
      *{box-sizing:border-box;margin:0;padding:0;}
      body{font-family:'Inter',Arial,sans-serif;background:#fff;padding:28px;color:#1a1a1a;font-size:11px;}
      .top-bar{height:4px;background:linear-gradient(90deg,#7B2D6B 0%,#a03880 55%,#E8541A 100%);border-radius:2px 2px 0 0;}
      .bottom-bar{height:4px;background:linear-gradient(90deg,#7B2D6B 0%,#a03880 55%,#E8541A 100%);border-radius:0 0 2px 2px;margin-top:12px;}
      table{width:100%;border-collapse:collapse;}
      th{padding:5px 8px;text-align:left;font-size:7px;letter-spacing:0.1em;text-transform:uppercase;color:#c0a0b8;font-weight:600;border-bottom:1px solid #e4d4e0;}
      @media print{body{padding:16px;} @page{margin:0;size:A4;} body{padding:20px 28px;}}
    </style></head><body>
    <div class="top-bar"></div>
    <div style="padding:12px 0 10px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #f0e8ed;margin-bottom:12px;">
      <div>
        <div style="font-size:6.5px;letter-spacing:0.22em;text-transform:uppercase;color:#E8541A;margin-bottom:3px;">Department Report</div>
        <div style="font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#7B2D6B;">Kallada Food Industries LLC</div>
        <div style="font-size:8px;color:#c0a0b8;margin-top:1px;">Dubai, United Arab Emirates</div>
      </div>
      <div style="text-align:right;">
        <div style="font-size:26px;font-weight:800;color:#7B2D6B;position:relative;display:inline-block;">BGH<span style="position:absolute;top:1px;right:-9px;width:7px;height:7px;background:#E8541A;border-radius:1.5px;display:inline-block;"></span></div>
        <div style="font-size:6px;letter-spacing:0.16em;text-transform:uppercase;color:#E8541A;font-weight:600;margin-top:3px;">Bettergrow Holding</div>
      </div>
    </div>
    <div style="background:#f9f3f8;border:1px solid #ede0ea;border-radius:3px;padding:8px 14px;margin-bottom:14px;display:flex;justify-content:space-between;align-items:center;">
      <div style="font-size:14px;font-weight:700;color:#7B2D6B;">${selectedDept}</div>
      <div style="display:flex;gap:20px;">
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Total Products</div><div style="font-size:11px;font-weight:700;color:#7B2D6B;">${deptProducts.length}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Report Date</div><div style="font-size:11px;font-weight:600;color:#333;">${today}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Prepared By</div><div style="font-size:11px;font-weight:600;color:#333;">${userName}</div></div>
      </div>
    </div>
    <div style="display:flex;border:1px solid #e4d4e0;border-radius:4px;overflow:hidden;margin-bottom:14px;">
      ${statusSummary}
    </div>
    <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
      <div style="width:3px;height:14px;background:#7B2D6B;border-radius:2px;"></div>
      <div style="font-size:7px;letter-spacing:0.2em;text-transform:uppercase;font-weight:700;color:#7B2D6B;">Products — ${selectedDept}</div>
      <div style="flex:1;height:1px;background:#7B2D6B;opacity:0.18;"></div>
    </div>
    <table>
      <thead><tr>
        <th style="width:85px;">Code</th><th>Product Name</th>
        <th style="width:120px;text-align:center;">Status</th>
        <th style="width:110px;">Project</th>
        <th style="width:80px;">Group</th>
        <th style="width:100px;text-align:right;">Recipe Cost</th>
      </tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <div style="margin-top:10px;text-align:center;">
      <span style="font-size:7px;color:#d0bfca;letter-spacing:0.07em;text-transform:uppercase;">Kallada Food Industries LLC · Confidential Document · ${today}</span>
    </div>
    <div class="bottom-bar"></div>
    </body></html>`);
    win.document.close();
    win.focus();
  };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    productsAPI.getAll({}).then(r => {
      const data = r.data;
      setProducts(data);
      const g = {};
      data.forEach(p => {
        const d = p.department || 'Unassigned';
        if (!g[d]) g[d] = [];
        g[d].push(p);
      });
      setGrouped(g);
      const deptParam = searchParams.get('dept');
      if (deptParam) setSelectedDept(deptParam);
      else if (Object.keys(g).length > 0) setSelectedDept(Object.keys(g)[0]);
    });
  }, []);

  const depts = Object.keys(grouped).sort();

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Products by Department</div>
          <div className="page-subtitle">View and track all products grouped by requesting department</div>
        </div>
        {selectedDept && <button className="btn btn-primary" onClick={printPDF}>⬇ Download / Print PDF</button>}
      </div>

      <div style={{ display: 'flex', gap: 24 }}>
        {/* Sidebar dept list */}
        <div style={{ width: 220, flexShrink: 0 }}>
          <div className="card" style={{ padding: '12px 8px' }}>
            <div className="card-title" style={{ padding: '0 10px', marginBottom: 10 }}>Departments</div>
            {depts.map(d => {
              const dProds = grouped[d];
              const launched = dProds.filter(p => p.status === 'launched').length;
              return (
                <div
                  key={d}
                  onClick={() => setSelectedDept(d)}
                  style={{
                    padding: '10px 12px',
                    borderRadius: 6,
                    cursor: 'pointer',
                    background: selectedDept === d ? 'var(--accent-dim)' : 'transparent',
                    borderLeft: selectedDept === d ? '2px solid var(--accent)' : '2px solid transparent',
                    marginBottom: 2,
                    transition: 'all 0.15s',
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: 13, color: selectedDept === d ? 'var(--accent)' : 'var(--text-primary)' }}>{d}</div>
                  <div className="text-muted mono" style={{ fontSize: 11 }}>{dProds.length} products · {launched} launched</div>
                </div>
              );
            })}
            {depts.length === 0 && <div className="text-muted" style={{ padding: '0 10px', fontSize: 13 }}>No data yet</div>}
          </div>
        </div>

        {/* Products for selected dept */}
        <div style={{ flex: 1 }}>
          {selectedDept && grouped[selectedDept] ? (
            <>
              <div className="stats-grid mb-6">
                {['trial', 'recipe_confirmed', 'commercial_trial', 'launched'].map(s => (
                  <div key={s} className="stat-card">
                    <div className="stat-label">{STATUS_LABELS[s]}</div>
                    <div className="stat-value">{grouped[selectedDept].filter(p => p.status === s).length}</div>
                  </div>
                ))}
              </div>

              <div className="card">
                <div className="card-title">{selectedDept} — All Products</div>
                <div className="table-wrap">
                  <table>
                    <thead>
                      <tr>
                        <th>Product Code</th>
                        <th>Name</th>
                        <th>Project</th>
                        <th>Group</th>
                        <th>Status</th>
                        <th className="text-right">Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      {grouped[selectedDept].map(p => (
                        <tr key={p.id} onClick={() => navigate(`/products/${p.id}`)}>
                          <td className="mono">{p.product_code}</td>
                          <td style={{ fontWeight: 500 }}>{p.name}</td>
                          <td className="text-muted">{p.project_name}</td>
                          <td className="mono">{p.internal_group}</td>
                          <td><span className={`badge badge-${p.status}`}>{STATUS_LABELS[p.status]}</span></td>
                          <td className="text-right cost-value">
                            {(devCost(p)) > 0 ? `AED ${(devCost(p)).toLocaleString('en-AE', { maximumFractionDigits: 0 })}` : '—'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            <div className="empty-state card">
              <div className="empty-state-icon">◧</div>
              <p>No products found. Start by adding products to your projects.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
